import React, { useRef , useState} from "react";
import Pixel from "./Pixel";
import {Box,IconButton,Typography,useTheme,Tooltip,Divider,Dialog,DialogActions, DialogTitle,DialogContent,TextField, DialogContentText, Button} from "@mui/material";
import { tokens } from "../../theme";
import { useDispatch, useSelector } from "react-redux";
import { deleteFrame, cloneFrame , updateFrame , selectFrame} from "../../slices/sign_image_editor"
import DeleteIcon from '@mui/icons-material/Delete';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';


const Frame = (props) =>  {

  const { selected , id, canDelete} = props;

  const theme = useTheme()
  const colors = tokens(theme.palette.mode);
  const dispatch = useDispatch();

  const frame = useSelector((state) => state.imageEditor.frames.find((frame) => frame.id === id));

  const [open, setOpen] = React.useState(false);
  const displayDuration = frame.duration / 1000;
  const [newDisplayDuration , setNewDisplayDuration] = useState(displayDuration)

  const border = selected ? "1px solid red" : ""

  const handleDurationChange = (event) => {
    setNewDisplayDuration(event.target.value);
  };

  const handleClickOpen = (e) => {
    e.stopPropagation();
    if (canDelete){
      setOpen(true);
    }
  };

  const handleCloseDuration = () => {

    setNewDisplayDuration(displayDuration);
    setOpen(false);
  };

  const handleUpdateDuration= () => {

    let updatedFrame = {
      ...frame,
      duration: newDisplayDuration * 1000,
    }

    dispatch(updateFrame({updatedFrame}))

    setOpen(false);
  };

  const deleteThisFrame = (e) => {
    e.stopPropagation();
    dispatch(deleteFrame({id}));

  } 

  const cloneThisFrame = (e) => {
    e.stopPropagation();
    dispatch(cloneFrame({id}));

  } 

  const setFrame = () => {
    dispatch(selectFrame(frame.id))
  }

  return (
    <>
    <Box 
      display="flex" 
      justifyContent="flex-end"
      flexDirection="column"
      width = "6rem"
      height= "6rem"
      p="0 .3rem 0 .3rem"
      mr=".5rem"
      backgroundColor={colors.primary[400]} 
      onClick={setFrame}
      sx={{ cursor: "pointer",  border: {border}}}
    >
      <Box>
        
      </Box>

      <Divider orientation="horizontal" variant="middle" flexItem />

      <Box
        display="flex"
        flexDirection="row"
        justifyContent="flex-start"
        alignItems="baseline"
      >
        <Tooltip title="Time in seconds the image is displayed" enterDelay={500} >
          <Typography 
            width = "100%"
            onClick={handleClickOpen}
            sx={{cursor: "pointer"}}
            
          >
            {canDelete 
              ? `${displayDuration}s`
              : <AllInclusiveIcon fontSize="small"/>
            }
          </Typography>
        </Tooltip>

        <Divider orientation="vertical" variant="middle" flexItem />

        <IconButton aria-label="delete" color="primary" onClick={deleteThisFrame} disabled={!canDelete} size="small">
          <DeleteIcon fontSize="inherit"/>
        </IconButton>

        <Divider orientation="vertical" variant="middle" flexItem />

        <IconButton aria-label="copy" color="primary" onClick={cloneThisFrame} size="small">
          <ContentCopyIcon fontSize="inherit"/>
        </IconButton>
      </Box>

    </Box>

    <Dialog open={open} maxWidth="xs">
      <DialogTitle>Frame Duration</DialogTitle>
      <DialogContent >
        <DialogContentText>
          Time in seconds this frame should be visible for. The settigng is ignored for single frame (static) images.
        </DialogContentText>
        <TextField
          inputProps = {{ 
            max: 3600, min: 0 
          }}
          autoFocus
          margin="dense"
          id="duration"
          label="Display duration"
          type="number"
          fullWidth
          variant="standard"
          value = {newDisplayDuration}
          onChange = {handleDurationChange}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="contained"  color="error"  onClick={handleCloseDuration}>Cancel</Button>
        <Button variant="contained"  color="secondary"  onClick={handleUpdateDuration}>Update</Button>
      </DialogActions>
    </Dialog>

    </>

  )
}

export default Frame;